const DescriptionsItem = _ref => {
  let {
    children
  } = _ref;
  return children;
};
export default DescriptionsItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/descriptions/Item.js
// module id = 3871
// module chunks = 0